import { useFormikContext } from "formik";
import {
  handleChangeHelper,
  handleOnAcceptHelper,
} from "./formikDatePickerHelper";
import { useContext } from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import moment from "moment";

function useFormikDatePicker() {
  const field = useContext(FormikControlContext);
  const { arrayIndex, productName } = field;
  const formik = useFormikContext();
  const { setFieldValue, values } = formik;

  const handleChange = (name, value) => {
    const formattedValue = moment(value).format("YYYY-MM-DD");
    setFieldValue(name, formattedValue); // Do not change this format (change only at backend, if needed)

    // Calling helper function
    handleChangeHelper(
      name,
      value,
      setFieldValue,
      productName,
      values,
      arrayIndex
    );
  };
  // TODO: Not working
  const handleOnAccept = (name, value) => {
    // Calling helper function
    handleOnAcceptHelper(
      name,
      value,
      setFieldValue,
      productName,
      values,
      arrayIndex
    );
  };

  return { handleChange, handleOnAccept };
}

export default useFormikDatePicker;
